import React from "react";

import { CaretDown } from "shared/assets/icons";
import { IconButton } from "shared/components";
import { space } from "shared/styles/constants";
import { ITheme } from "shared/types";

import { StyledActionDropdownTrigger } from "../styles";

interface ActionDropdownTriggerProps {
  label?: string; // required for a11y
  icon?: React.ComponentType<any>;
  iconSize?: keyof typeof space;
  triggerIcon?: React.ComponentType<any>;
  handleClick: () => void;
  isOpen?: boolean;
  isActive?: boolean;
  theme?: ITheme;
  hideContainer?: boolean;
  size?: "s" | "m";
}

export const ActionDropdownTrigger = React.forwardRef<
  HTMLButtonElement,
  ActionDropdownTriggerProps
>(
  (
    {
      label,
      icon,
      triggerIcon,
      handleClick,
      isOpen,
      isActive,
      theme = ITheme.secondary,
      hideContainer,
      size,
      ...rest
    },
    ref
  ) => {
    return (
      <>
        {triggerIcon ? (
          <>
            <IconButton
              label={label}
              onClick={handleClick}
              icon={triggerIcon}
              theme={theme}
              {...rest}
            />
          </>
        ) : (
          <StyledActionDropdownTrigger
            size={size}
            icon={icon}
            ref={ref}
            label={label}
            actionIcon={CaretDown}
            handleClick={handleClick}
            isOpen={isOpen}
            hideContainer={hideContainer}
            isActive={isActive}
            {...rest}
          />
        )}
      </>
    );
  }
);
